<template>
<div class="px-md-10">
    <ValidationObserver ref="observer">
        <v-form>
            <v-row>
                <v-col cols="12" sm="6" class="py-0">
                    <ValidationProvider v-slot="{ errors }" name="Name" rules="required">
                        <v-text-field :error-messages="errors" :disabled="loading" v-model="user.name" label="Full Name" outlined dense required></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                    <ValidationProvider v-slot="{ errors }" name="Company" rules="required">
                        <v-text-field :error-messages="errors" :disabled="loading" v-model="user.company" label="Company" outlined dense required></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                    <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                        <v-text-field :error-messages="errors" v-model="user.email" :disabled="loading" label="Email" outlined dense required></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                    <ValidationProvider name="confirm" rules="required" v-slot="{ errors }">
                        <v-text-field :error-messages="errors" :append-icon="passwardShow ? 'mdi-eye' : 'mdi-eye-off'" :type="passwardShow ? 'text' : 'password'" @click:append="passwardShow = !passwardShow" :disabled="loading" v-model="user.password" label="Password" outlined dense required></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                    <ValidationProvider v-slot="{ errors }" name="Password" rules="required|password:@confirm">
                        <v-text-field :error-messages="errors" type="password" :disabled="loading" v-model="confirmPassword" label="Confirm your password" outlined dense required></v-text-field>
                    </ValidationProvider>
                </v-col>
            </v-row>
            <v-card-actions class="px-0 pb-6">
                <v-btn color="blue darken-1" block class="px-4" :loading="loading" dark @click="registerClick">Register</v-btn>
            </v-card-actions>
            <div>
                <v-divider class="mb-4"></v-divider>
                <p class="grey--text text-center">Already a member? <router-link class="anchor--text font-weight-bold" to="/login">Login</router-link></p>
                <br>
            </div>
        </v-form>
    </ValidationObserver>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from 'vuex'
import { required, email } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})
extend('email', {
    ...email,
    message: 'Email must be valid',
})
extend('password', {
    params: ['target'],
    validate(value, { target }) {
        return value === target;
    },
    message: 'Password confirmation does not match'
});
export default {
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data() {
        return {
            alert: false,
            text: '',
            user: {
                name: "",
                email: "",
                company: "",
                password: ""
            },
            loading: false,
            ip_address: '',
            passwardShow: false,
            valid: false,
            confirmPassword: ""
        }
    },
    computed: {
        passwordConfirmationRule() {
            return () =>
                this.user.password === this.confirmPassword || "Password must match";
        }
    },
    methods: {
        ...mapActions(['PutResponse']),
        ...mapMutations(['AlertErr', 'SnackbarSuccess', 'status_success', 'status_invalid']),
        async registerClick() {
            this.$refs.observer.validate().then(async (res) => {
                if (res) {
                    this.loading = true
                    try {
                        let value = {
                            url: '/internal/v2/register',
                            data: this.user
                        }
                        const data = (await this.PutResponse(value)).data
                        if (data.success) {
                            this.status_success(false);
                            this.loading = false;
                            this.SnackbarSuccess(data);
                            this.user = {}
                            this.$refs.observer.reset()
                            this.confirmPassword = "";
                            this.$emit('Login');
                        } else {
                            this.status_success(true)
                            this.user = {}
                            this.$refs.observer.reset()
                            this.confirmPassword = "";
                            this.$emit('Login');
                        }
                    } catch (error) {
                        this.status_success(true);
                        let data = {
                            success: !error.response.data.success,
                            message: error.response.data.errors[0].message,
                            action: 'error'
                        }
                        this.SnackbarSuccess(data)
                        this.loading = false
                    }
                }
            })
        }
    },
    mounted() {
        this.$root.$on('resetValid', () => {
            this.user = {}
            this.$refs.observer.reset()
        })
    }
}
</script>
